import React, { useState, useEffect, type ChangeEvent } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Button from "@mui/material/Button";
import { Box, TextField } from "@mui/material";
import SnackbarCustom, {
  type SnackbarData,
} from "../../../../components/SnackBarCustom";
import PopoverCustom from "../../../../components/PopoverCustom";
import {
  getTemplateMail,
  createTemplateMail,
  updateTemplateMail,
} from "../../../../api";
import type { TemplateMailPayload } from "../../../../types/mail";

type TemplateFormState = {
  title: string;
  content: string;
};

export default function TemplateRegistration() {
  const navigate = useNavigate();
  const handleGoBack = () => {
    navigate(-1);
  };

  const searchParams = new URLSearchParams(useLocation().search);
  const templateId = searchParams.get("id");

  const [templateMail, setTemplateMail] = useState<TemplateFormState>({
    title: "",
    content: "",
  });

  const fetchTemplateMail = async () => {
    if (!templateId) {
      return;
    }
    try {
      console.log("メールテンプレート取得入力データ", templateId);
      const response = await getTemplateMail(templateId);
      if (response.status !== "ok") {
        return;
      }
      const data = response.template_mail;
      console.log("メールテンプレート情報取得", response);
      setTemplateMail({ title: data.title, content: data.content });
      setSnackBarstatus(response);
      setSnackbarOpen(true);
    } catch (error) {
      console.error("API呼び出しエラー", error);
    }
  };

  const putPostMessage = templateId ? (
    <div>更新しますか？</div>
  ) : (
    <div>登録しますか？</div>
  );

  const [confirmPopoverOpen, setPopoverSplitOpen] = useState(false);
  const putPostButtonClick = () => {
    setPopoverSplitOpen(true);
  };
  const confirmPopupClose = () => {
    setPopoverSplitOpen(false);
  };

  const putPostTemplateMail = async (isSuccess: boolean) => {
    if (!isSuccess) {
      console.log("何も行いません");
      return;
    }

    const params: TemplateMailPayload = {
      title: templateMail.title,
      content: templateMail.content,
    };
    console.log("メールテンプレート情報更新登録入力内容", params);
    try {
      const response = templateId
        ? await updateTemplateMail(templateId, params)
        : await createTemplateMail(params);
      if (response.status === "ok" && "template_mail" in response) {
        const data = response.template_mail;
        if (data) {
          setTemplateMail({ title: data.title, content: data.content });
        }
      }
      console.log("メールテンプレート情報更新登録", response);
      setSnackBarstatus(response);
      setSnackbarOpen(true);
    } catch (error) {
      console.error("API呼び出しエラー", error);
    }
  };

  const pageContent = [{ title: "登録" }, { title: "更新" }];
  const [pageValidate, setPageValidate] = useState(0);
  const settingTemplate = () => {
    setPageValidate(1);
    fetchTemplateMail();
  };

  useEffect(() => {
    if (templateId === null) {
      setPageValidate(0);
    } else {
      settingTemplate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeTitle = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setTemplateMail((prevValue) => ({
      ...prevValue,
      title: newValue,
    }));
  };

  const handleChangeContent = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setTemplateMail((prevValue) => ({
      ...prevValue,
      content: newValue,
    }));
  };

  const [snackBarstatus, setSnackBarstatus] = useState<SnackbarData>();
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          "@media screen and (max-width:900px)": {
            flexDirection: "column",
            gap: "-16px",
          },
        }}
      >
        <Box
          onClick={handleGoBack}
          sx={{
            display: "flex",
            height: "48px",
            alignItems: "center",
            paddingLeft: "40px",
            fontSize: 20,
            fontWeight: "bold",
            whiteSpace: "nowrap",
            color: "primary.main",
            cursor: "pointer",
            textDecoration: "underline",
            "&:hover": {
              color: "primary.dark",
            },
            "&:active": {
              color: "primary.light",
            },
            "@media screen and (max-width:900px)": {
              paddingLeft: 2,
            },
          }}
        >
          メールテンプレート一覧
        </Box>
        <Box
          sx={{
            display: "flex",
            height: "48px",
            alignItems: "center",
            fontSize: 20,
            fontWeight: "bold",
            whiteSpace: "nowrap",
            "@media screen and (max-width:900px)": {
              paddingLeft: 2,
            },
          }}
        >
          /メールテンプレート{pageContent[pageValidate].title}
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "fit-content",
          justifyContent: "center",
          borderRadius: 2,
          borderColor: "primary.main",
          boxShadow: 3,
          color: "outline.dark",
          backgroundColor: "#fff",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "fit-content",
            justifyContent: "center",
            gap: "16px",
            paddingTop: "32px",
            paddingRight: "40px",
            paddingLeft: "40px",
            paddingBottom: "32px",
            "@media screen and (max-width:900px)": {
              padding: "16px",
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "16px",
              "@media screen and (max-width:600px)": {
                flexDirection: "column",
                width: "100%",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                width: "100%",
                maxWidth: "480px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minWidth: "min-content",
                  fontSize: 16,
                  fontWeight: "bold",
                  color: "#000",
                  whiteSpace: "nowrap",
                  "@media screen and (max-width:900px)": {
                    flexDirection: "column",
                    width: "100%",
                    alignItems: "flex-start",
                  },
                }}
              >
                <Box sx={{ minWidth: "160px" }}>件名</Box>
                <TextField
                  name="titleTextField"
                  id="outlined-basic"
                  variant="outlined"
                  size="small"
                  value={templateMail.title || ""}
                  onChange={handleChangeTitle}
                  sx={{
                    width: "100%",
                    ".MuiInputBase-root": {
                      height: "100%",
                    },
                    "#outlined-basic": {
                      boxSizing: "border-box",
                      height: "100%",
                    },
                  }}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minWidth: "min-content",
                  fontSize: 16,
                  fontWeight: "bold",
                  color: "#000",
                  whiteSpace: "nowrap",
                  "@media screen and (max-width:900px)": {
                    flexDirection: "column",
                    width: "100%",
                    alignItems: "flex-start",
                  },
                }}
              >
                <Box sx={{ minWidth: "160px" }}>本文 </Box>
                <TextField
                  name="contentTextField"
                  id="outlined-basic"
                  variant="outlined"
                  value={templateMail.content || ""}
                  onChange={handleChangeContent}
                  multiline
                  rows={3}
                  sx={{
                    height: "100%",
                    width: "100%",
                    ".MuiInputBase-root": {
                      height: "100%",
                    },
                    "#outlined-basic": {
                      boxSizing: "border-box",
                      height: "100%",
                    },
                  }}
                />
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: "16px",
              "@media screen and (max-width:600px)": {
                flexDirection: "column",
                alignItems: "center",
              },
            }}
          >
            <Button
              name="putPostButton"
              variant="contained"
              sx={{ width: "208px" }}
              onClick={putPostButtonClick}
            >
              {pageContent[pageValidate].title}
            </Button>
          </Box>
        </Box>
      </Box>
      <SnackbarCustom
        data={snackBarstatus}
        openStatus={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
      />
      <PopoverCustom
        open={confirmPopoverOpen}
        onClose={confirmPopupClose}
        yesNo={putPostTemplateMail}
        title={templateId ? "更新確認" : "登録確認"}
        contents={putPostMessage}
      />
    </>
  );
}
